/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {BundleDetailContract} from '../../../api/contracts/bundle/bundle-detail.contract';
import {BundleDetailModel} from './bundle-detail.model';
import {ReferenceDataMapper} from '../../reference-data/reference-data.mapper';
import {BundlePositionsDetailMapper} from '../bundle-positions-detail/bundle-positions-detail.mapper';
import {BundleSpecDetailMapper} from '../bundle-spec-detail/bundle-spec-detail.mapper';
import {CriterionBaseMapper} from '../../criterion-base/criterion-base.mapper';
import {ValueBaseMapper} from '../../value-base/value-base.mapper';

export class BundleDetailMapper {

    static fromBundleDetailContractArray(input: BundleDetailContract[]): BundleDetailModel[] {
        return input?.map((element) => BundleDetailMapper.fromBundleDetailContract(element));
    }

    static fromBundleDetailContract(input: BundleDetailContract): BundleDetailModel {
        let model: BundleDetailModel;
        let totalSettlements = 0;

        if (input != null) {
            input.bundlePositions?.forEach((item) => totalSettlements += item.settlementsList.length);
            model = {
                number: input.number,
                status: ReferenceDataMapper.fromReferenceDataContract(input.status),
                totalValue: input.totalValue,
                spec: BundleSpecDetailMapper.fromBundleSpecBaseContract(input.spec),
                bundlePositions: BundlePositionsDetailMapper.fromBundlePositionsDetailContractArray(input.bundlePositions),
                totalCostProgress: input.totalCostProgress,
                criteria: CriterionBaseMapper.fromCriterionBaseContractArray(input.criteria),
                values: ValueBaseMapper.fromValueBaseContractArray(input.values),
                closedBy: input.closedBy,
                closedOn: input.closedOn,
                metadata: input.metadata,
                availableActions: input.availableActions != null ? [...input.availableActions] : undefined,
                sent: input.sent,
                sentBy: input.sentBy,
                sentOn: input.sentOn,
                totalSettlements: totalSettlements
            };
        }
        return model;
    }
}
